/**
 * Enum for Layer Types
 * @readonly
 * @enum {number}
 */
const LayerTypes = {'Filter': 0, 'Native': 1, 'Supply': 2, 'Thematic': 3, 'Upload': 4, 'UserDraw': 5}
const DefaultProject = {defaultColor: '#000000', objectid: 1, zoomThreshold: 13}
const GridTypes = ['hexagon', 'square']
const LayerPrefixes = ['circle', 'symbol', 'vector', 'cluster', 'heatmap-data', 'heatmap', 'raster', 'fill', 'hl-fill', 'thematic', 'filter', 'line', 'label', 'label-vector']
const RenderMode = {'Point': 1, 'LineString': 9, 'Polygon': 8}
const SpecialTypes = ['heatmap', 'thematic', ...GridTypes]
const InterceptMode = {'Centroid': 0, 'Vertex': 1}
const StyleTypes = [
{name: 'Ruas', tag:'streets-v11',  value: 'mapbox://styles/mapbox/streets-v11', image: 'ic_default-2x.png'},
{name: 'Google', tag:'google', value: {
  version: 8,
  glyphs: 'https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf', // 🔹 Adiciona suporte a fontes
  sources: {
    'google-maps-source': {
      type: 'raster',
      tiles: ['https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}'], // Google Maps padrão
      tileSize: 256
    }
  },
  layers: [
    {
      id: 'google-maps-layer',
      type: 'raster',
      source: 'google-maps-source',
      paint: {}
    }
  ]
}, image: 'ic_google-2x.png'
},
{name: 'Claro', tag:'light-v10', value: 'mapbox://styles/mapbox/light-v10', image: 'ic_light-2x.png'},
{name: 'Escuro', tag:'dark-v10', value: 'mapbox://styles/mapbox/dark-v10', image: 'ic_dark-2x.png'},
{name: 'Ar Livre', tag:'outdoors-v11', value: 'mapbox://styles/mapbox/outdoors-v11', image: 'ic_terrain-2x.png'},
{name: 'Satélite com Ruas', tag:'satellite-streets-v11', value: 'mapbox://styles/mapbox/satellite-streets-v11', image: 'camadas.jpg'},
{name: 'Navegação Diurna', tag:'navigation-day-v1', value: 'mapbox://styles/mapbox/navigation-day-v1', image: 'ic_transit-2x.png'},
{name: 'Navegação Noturna', tag:'navigation-night-v1', value: 'mapbox://styles/mapbox/navigation-night-v1', image: 'ic_traffic-2x.png'}
]

export default {
  DefaultProject,
  GridTypes,
  InterceptMode,
  LayerPrefixes,
  LayerTypes,
  RenderMode,
  SpecialTypes,
  StyleTypes
}
